import React from 'react';
import { OverlayControl, OverlayControlProps } from 'components/OverlayControl';

type GridPanelControlProps = OverlayControlProps;

export const GridPanelControl = React.forwardRef<HTMLButtonElement, GridPanelControlProps>(
  (props, ref) => <OverlayControl ref={ref} className="grid-panel-control" {...props} />
);
